import React from "react";
import { useNavigate } from "react-router-dom";
import TrendLogo from "assets/trending.png";
import { paths } from "utils/constants";

const Logo = () => {
  const navigate = useNavigate();

  const onNavigateHome = () => navigate(paths.home);

  return (
    <div
      className="flex justify-center items-center h-20 logo-section"
      onClick={onNavigateHome}
    >
      <div className="flex items-center rounded-lg select-none cursor-pointer">
        <img src={TrendLogo} alt="" className="w-8" />
        <h1 className="text-white pt-2.5 pl-1 text-3xl font-kalam">
          Dindicator
        </h1>
      </div>
    </div>
  );
};

export default Logo;
